// Parallax-Effekt für das Hero-Bild der Landingpages.
// Portiert aus juve.patent (themes/juve-patent/js/modules/parallax.js).
//
// Das lp-hero-Twig-Partial setzt die Klasse "js-lp-parallax" direkt auf
// das Background-Bild-Element (.lp-hero__image). Dieses Modul übernimmt
// das Scroll-basierte Translate-Movement.

const applyParallax = (element) => {
    const speed = parseFloat(element.dataset.parallaxSpeed) || 0.4;

    // CSS-Fallback (background-attachment: fixed) deaktivieren —
    // JS übernimmt das Movement.
    const target = element;
    target.style.backgroundAttachment = 'scroll';

    window.addEventListener(
        'scroll',
        () => {
            const {scrollY} = window;
            const parent = target.offsetParent;
            if (!parent) {
                return;
            }
            const bottom = parent.offsetTop + parent.offsetHeight;

            if (scrollY < bottom) {
                target.style.transform = `translateY(${scrollY * speed}px)`;
            }
        },
        {passive: true},
    );
};

const landingpageParallax = () => {
    const elements = document.querySelectorAll('.js-lp-parallax');
    if (!elements.length) {
        return;
    }

    elements.forEach(applyParallax);
};

export default landingpageParallax;
